(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/javascripts/views/init-tabs.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/javascripts/views/init-tabs.js'); 
(function(Backbone, svs) {
  svs.terms_integrity.views.InitTabs = Backbone.Marionette.View.extend({
    template: function(data) {
      return svs.terms_integrity.templates.init_tabs(data);
    },

    initialize: function(options) {
      this.initialSelectedTab = options ? options.tab : '';
      this.setupTabs();
    },

    setupTabs: function() {
      this.tabViews = [
        {
          caption: 'Personuppgifter',
          id: 'personuppgifter',
          view: new svs.terms_integrity.views.PersonData({
            model: svs.terms_integrity.models.personData || new svs.terms_integrity.models.PersonData()
          })
        },
        {
          caption: 'Villkor',
          id: 'villkor',
          view: new svs.terms_integrity.views.TermsDocs({
            model: svs.terms_integrity.models.termsDocs || new svs.terms_integrity.models.TermsDocs()
          })
        },
        {
          caption: 'Spelregler',
          id: 'spelregler',
          view: new svs.terms_integrity.views.RulesDocs({
            model: svs.terms_integrity.models.rulesDocs || new svs.terms_integrity.models.RulesDocs()
          })
        },
        {
          caption: 'Cookies',
          className: 'cookies',
          id: 'cookies',
          view: new svs.terms_integrity.views.Cookies({
            model: svs.terms_integrity.models.cookies || new svs.terms_integrity.models.Cookies()
          })
        }
      ];
    },

    onAttach: function() {
      this.renderTabs();
    },
    renderTabs: function() {
      var self = this;

      this.tabView = new svs.components.Tabs({
        tabs: this.tabViews,
        el: this.$('#terms-integrity-tabview'),
        selected: self.initialSelectedTab,
        path: true,
        solidNav: true,
        defaultScroll: true,
        defaultTab: 'villkor',
        slideOnDrag: !svs.core.detect.formfactor.desktop(),
        sliderOptions: { fadeinLoadedSlide: false },
        noDetectActiveTab: false
      });
    }
  });
})(Backbone, svs);

 })(window);